<template>
  <div class="flex flex-col flex-1 items-center justify-center px-5 py-4">
    <!-- Saving State -->
    <div v-if="isSaving" class="flex flex-col items-center gap-4">
      <div
        class="w-16 h-16 border-4 border-[#FEC629] border-t-transparent rounded-full animate-spin"
      ></div>
      <p class="text-sm text-[#637083] font-medium">Saving your Easter egg...</p>
    </div>

    <!-- Success State -->
    <div v-else-if="saveResult && !saveError" class="flex flex-col items-center gap-6">
      <div class="celebration-egg">
        <img
          v-if="exportedImage"
          :src="exportedImage"
          alt="Your Easter egg"
          class="w-[200px] h-[250px] object-contain"
          :style="{ clipPath: eggClipPath }"
        />
        <EggTemplate v-else :width="200" :height="250" template-id="yellow" />
      </div>
      <div class="flex flex-col items-center gap-2 text-center">
        <h2 class="text-xl font-bold text-[#373E49]">Egg saved!</h2>
        <p class="text-sm text-[#637083]">Your egg design has been saved to your collection.</p>
      </div>
      <div class="flex flex-col gap-3 w-full max-w-[280px]">
        <button
          class="w-full py-[12px] px-[24px] text-[1rem] leading-[1.5rem] font-[700] text-[#21201E] bg-[#FEC629] rounded-[100px] hover:bg-[#E6B025] transition-all duration-200 active:scale-[0.98]"
          @click="$emit('share')"
        >
          Share
        </button>
        <button
          class="w-full py-[12px] px-[24px] text-[1rem] leading-[1.5rem] font-[700] text-[#637083] rounded-[100px]"
          @click="$emit('done')"
        >
          Back to Home
        </button>
      </div>
    </div>

    <!-- Error State -->
    <div v-else-if="saveError" class="flex flex-col items-center gap-4 text-center">
      <div class="w-16 h-16 rounded-full bg-[#FDECEB] flex items-center justify-center">
        <span class="text-3xl text-[#CC1100]">!</span>
      </div>
      <div class="flex flex-col gap-1">
        <h2 class="text-lg font-bold text-[#373E49]">Something went wrong</h2>
        <p class="text-sm text-[#637083]">{{ saveError }}</p>
      </div>
      <button
        class="w-full max-w-[280px] py-[12px] px-[24px] text-[1rem] leading-[1.5rem] font-[700] text-[#21201E] bg-[#FEC629] rounded-[100px] hover:bg-[#E6B025] transition-all duration-200 active:scale-[0.98]"
        @click="$emit('retry')"
      >
        Try Again
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getEggClipPathCSS } from '@/utils/egg-shape';
import EggTemplate from './EggTemplate.vue';

export default {
  name: 'EasterEggConfirmation',
  components: {
    EggTemplate,
  },
  emits: ['done', 'retry', 'share'],
  data() {
    return {
      eggClipPath: getEggClipPathCSS(),
    };
  },
  computed: {
    ...mapState('easterEgg', ['isSaving', 'saveError', 'saveResult', 'exportedImage']),
  },
};
</script>

<style scoped>
.celebration-egg {
  animation: celebrate 0.6s ease-in-out 3;
}

@keyframes celebrate {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.08) rotate(-3deg);
  }
  75% {
    transform: scale(1.08) rotate(3deg);
  }
}
</style>
